// eslint-disable-next-line import/no-unresolved
module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-dates/index.js
// module id = 4285
// module chunks = 168707334958949